import { InjectionToken } from '@angular/core';

export interface Environment {
  oAuthClientId: string;
  stytchPublicToken: string;
  ldClientId: string;
  productName: string;
  giphyApiKey: string;
  streamApiKey: string;
  uri: {
    webSocket: string;
    blueWebSocket: string;
    stytchApi: string;
    apiBase: string;
    blueApiBase: string;
    electronProtocol: string;
    appDownload: string;
    blueAppDownload: string;
  };
  isProduction: boolean;
}

export const ENVIRONMENT = new InjectionToken<Environment>('environment');
